<ng-container *ngIf="currentFile">
  <div class="file-preview-dialog" [class.rtl]="isRTL" #dialogContainer>
    <!-- Header - Always visible -->
    <header class="file-preview-header">
      <span class="fw-regular">{{ currentFile.uploadDateFormatted }}</span>
      <i class="fas fa-times t-popupCloseIcon" (click)="closePanel()"></i>
    </header>

    <!-- Main content area with navigation -->
    <div class="file-preview-main">
      <!-- Left navigation arrow -->
      <div
        class="nav-arrow nav-arrow-left"
        (click)="hasPrev() ? prev() : null"
        [class.disabled]="!hasPrev()"
      >
        <img src="assets\img\Right.svg" [class.rotateY]="!isRTL" />
      </div>

      <!-- Content area -->
      <div class="file-preview-content">
        <!-- Image preview -->
        <div *ngIf="isImg()" class="preview-container img-preview">
          <image-view [imgSrc]="currentFile.url"></image-view>
        </div>

        <!-- PDF preview -->
        <div *ngIf="isPdf() && pdfUrl" class="preview-container pdf-preview">
          <iframe [src]="pdfUrlSafe"></iframe>
          <!-- <pdf-viewer [fileUrl]="pdfUrl"></pdf-viewer> -->
        </div>

        <!-- HTML preview -->
        <div *ngIf="isHtml()" class="preview-container html-preview">
          <iframe [src]="htmlUrlSafe"></iframe>
        </div>

        <!-- Video preview -->
        <div
          *ngIf="currentFile.videoSrc"
          class="preview-container video-preview"
        >
          <video controls [src]="currentFile.videoSrc">
            Your browser does not support the video tag.
          </video>
        </div>
      </div>

      <!-- Right navigation arrow -->
      <div
        class="nav-arrow nav-arrow-right"
        (click)="hasNext() ? next() : null"
        [class.disabled]="!hasNext()"
      >
        <img src="assets\img\Right.svg" [class.rotateY]="isRTL" />
      </div>
    </div>

    <!-- Footer - Always visible -->
    <footer class="file-preview-footer">
      <div *ngIf="allowSendInChat" class="footer-chat-buttons">
        <a *ngFor="let c of currentOrder.chatContacts" (click)="sendInChat(c)">
          <img
            *ngIf="c.contactId === 'LAB'"
            class="icon"
            src="assets/img/send_to/Brosh_btn.svg"
            alt="Send to Lab"
          />
          <img
            *ngIf="c.contactId === 'CLINIC'"
            class="icon"
            src="assets/img/send_to/Clinic_btn.svg"
            alt="Send to Clinic"
          />
          <img
            *ngIf="c.contactId === 'PLANT'"
            class="icon"
            src="assets/img/send_to/Plant_btn.svg"
            alt="Send to Plant"
          />
        </a>
      </div>
      <div class="footer-action-buttons">
        <a *ngIf="isImg()" (click)="rotate()">
          <img class="icon" src="assets\img\Rotate.svg" />
        </a>
        <a *ngIf="isImg()" (click)="zoomIn()">
          <img class="icon" src="assets\img\ZoomIn.svg" />
        </a>
        <a *ngIf="isImg()" (click)="zoomOut()">
          <img class="icon" src="assets\img\ZoomOut.svg" />
        </a>
        <a
          *ngIf="isImg() || isPdf() || isHtml()"
          (click)="openUrl()"
          title="Open in new tab"
          class="circular-icon-btn"
        >
          <i class="fas fa-external-link-alt"></i>
        </a>
        <a *ngIf="!isHtml() && !isPdf()" (click)="download()">
          <img class="icon" src="assets\img\Download.svg" />
        </a>
        <!-- <a *ngIf="isHtml()" (click)="openUrl()">
          <img
            class="icon"
            *ngIf="!currentFile.modelType"
            src="assets\img\3D_Scan_new.svg"
          />
          <img
            class="icon"
            *ngIf="currentFile.modelType == 'IMPRINT'"
            src="assets\img\3D_scanner_icon.svg"
          />
          <img
            class="icon"
            *ngIf="currentFile.modelType == 'DESIGN'"
            src="assets\img\3D_cast_icon.svg"
          />
        </a> -->
        <a
          *ngIf="isHtml()"
          (click)="copyToClipboard()"
          title="Copy URL to clipboard"
          class="circular-icon-btn"
        >
          <i class="fas fa-paperclip"></i>
        </a>
        <!-- <a *ngIf="isPdf()" (click)="openUrl()">
          <img class="icon" src="assets\img\PDF_Files.svg" />
        </a> -->
        <a *ngIf="allowDeleteFile" (click)="delete()">
          <img class="icon" src="assets\img\Delete.svg" />
        </a>
      </div>
    </footer>
  </div>
</ng-container>
